// extracted by mini-css-extract-plugin
module.exports = {"component":"TyreSizePicker_component__WKTUM"};